import { Component, Input, ViewContainerRef } from '@angular/core'
import { ActiveFacetsComponent, FacetService } from '@spartacus/storefront'
import { Occ } from '@spartacus/core'
import { of } from 'rxjs'
import { MbSpinnerService } from '../../../../shared/services/mb-spinner.service'
import { map } from 'rxjs/operators'
import Breadcrumb = Occ.Breadcrumb

@Component({
  selector: 'mb-active-facets',
  templateUrl: './mb-active-facets.component.html',
  styleUrls: ['./mb-active-facets.component.scss']
})
export class MbActiveFacetsComponent extends ActiveFacetsComponent {

  activeFacets$ = this.facetList$.pipe(
    map(facets => this.sortFacets(facets.activeFacets))
  )

  @Input()
  set activeFacets (activeFacets: Breadcrumb[] | undefined) {
    if (activeFacets) {
      this.activeFacets$ = of(activeFacets).pipe(
        map(facets => this.sortFacets(facets))
      )
    }
  }

  @Input()
  readOnlyFacets: Breadcrumb[] | undefined

  constructor (protected facetService: FacetService,
               protected mbSpinnerService: MbSpinnerService,
               protected vcr: ViewContainerRef) {
    super(facetService)
  }

  protected sortFacets (facets?: Breadcrumb[]) {
    return [...facets || []].sort((a, b) => a.facetCode?.toUpperCase().localeCompare(b.facetCode?.toUpperCase() || '') || 0)
  }

  getLogicalTerm (previousFacet: Breadcrumb,
                 currentFacet: Breadcrumb) {
    return `searchFilterPane.${previousFacet?.facetCode === currentFacet?.facetCode && 'or' || 'and'}`
  }

  isFacetReadOnly (facet?: Breadcrumb) {
    return !!facet && this.readOnlyFacets?.some(readOnlyFacet =>
      readOnlyFacet?.facetCode === facet.facetCode &&
      readOnlyFacet?.facetValueCode === facet.facetValueCode)
  }

  onRemoveFacetClick () {
    this.mbSpinnerService.launchMbSpinner(this.vcr)
  }
}
